import React  from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import { SimpleNumber } from '../../components/common/number/simple-number';
import {Currency } from '../../components/common/number';
import styles from './dashboard-styles';

function TotalMarketValueView({
    messages,
    marketTotal
}){

    return(
        <div className="summaryTotal-container">
            <span className="summaryTotal-title">
            {messages['app.dashboard.summaryData.marketValue.total.title']}
            </span>
            <span className="summaryTotal-value">
                <Currency
                    signBeforeNumber={false}
                    decimalStyle={styles.decimelStyle}
                    renderProps={{
                        style: styles.marketTotalNomination,
                        size: 20
                    }}
                    value={marketTotal}
                />
                {/* <SimpleNumber
                renderProps={{
                    style: styles.marketTotal,
                  }}
                minimumFractionDigits={2}
                maximumFractionDigits={2}
                value={marketTotal}/> */}
            </span>
            <span className="summaryTotal-proportion">
            {messages['app.dashboard.summaryData.proportion.total']}
            </span>
        </div>
    );

}
   
TotalMarketValueView.propTypes = {
    marketTotal: PropTypes.number,
    prefCurrency: PropTypes.string,
  };
  
  
export default pure(TotalMarketValueView);